import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { notification } from 'antd';
import { setProfile } from '../../store/interfaceSlice';
import { normalizeProfileFromServer } from '../../utils/helpers';
import { emitWhenConnected } from '../socketHelpers';

export function useProfileApi(socket) {
  const dispatch = useDispatch();

  const getProfileFromServer = useCallback(
    (callback) => {
      if (!socket) {
        if (callback) callback('Сокет не подключен', null);
        return;
      }

      emitWhenConnected(socket, () => {
        socket.emit('get_profile', (response) => {
          if (response?.status === 'ok' && response?.profile) {
            const normalized = normalizeProfileFromServer(response.profile);
            dispatch(setProfile(normalized));
            if (callback) callback(null, normalized);
          } else if (callback) {
            callback(response?.message || 'Не удалось получить профиль', null);
          }
        });
      });
    },
    [socket, dispatch]
  );

  const updateProfileOnServer = useCallback(
    (profilePayload, callback) => {
      if (!socket) {
        if (callback) callback('Сокет не подключен', null);
        return;
      }

      let payloadToSend = { ...profilePayload };
      try {
        const dataUrl = profilePayload?.avatarDataUrl;
        if (typeof dataUrl === 'string' && dataUrl.startsWith('data:')) {
          const match = dataUrl.match(/^data:(.*?);base64,(.*)$/);
          if (match) {
            const [, mime, b64] = match;
            payloadToSend.avatar = b64;
            payloadToSend.avatar_mime = mime;
          }
        }
      } catch {
        /* ignore */
      }

      emitWhenConnected(socket, () => {
        socket.emit('update_profile', payloadToSend, (response) => {
          if (response?.status === 'ok') {
            const newProfile = normalizeProfileFromServer(response.profile || profilePayload);
            if (!newProfile?.avatarDataUrl && profilePayload?.avatarDataUrl) {
              newProfile.avatarDataUrl = profilePayload.avatarDataUrl;
            }
            dispatch(setProfile(newProfile));
            if (callback) callback(null, newProfile);
          } else {
            const errMsg = response?.message || 'Ошибка при обновлении профиля';
            if (callback) callback(errMsg, null);
            notification.error({ message: 'Не удалось сохранить профиль', description: errMsg });
          }
        });
      });
    },
    [socket, dispatch]
  );

  return { getProfileFromServer, updateProfileOnServer };
}
